import { AxiosPromise, AxiosStatic } from "axios";
import { TScheduleNotificationPayload, TSimpleMessage } from "../types";

const scheduleNotifications =
  (serverURL: string, appAxios: AxiosStatic, token: string) =>
  async ({
    authUserId,
    namespace,
    notifications,
  }: TScheduleNotificationPayload): AxiosPromise<TSimpleMessage> =>
    await appAxios.post(
      `${serverURL}/admin/schedule-notification`,
      { authUserId, namespace, notifications },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

export default scheduleNotifications;
